import { render, staticRenderFns } from "./HomeLink.vue?vue&type=template&id=000d4f2a&scoped=true&"
import script from "./HomeLink.vue?vue&type=script&lang=js&"
export * from "./HomeLink.vue?vue&type=script&lang=js&"
import style0 from "./HomeLink.vue?vue&type=style&index=0&id=000d4f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000d4f2a",
  null
  
)

export default component.exports